import { memo } from 'react';
import { useSelector } from 'react-redux';

import { type AssetCustomFieldValue } from '@air/api/types';

import { usePublicPermissions } from '~/components/PublicPermissionsProvider';
import { centralizedClipAssetIdSelector } from '~/store/centralizedClip/selectors';
import { canChangeAssetCustomFields } from '~/utils/permissions/assetPermissions';
import { PublicAssetCustomFieldDateInput } from './PublicAssetCustomFieldDateInput';
import { PublicAssetPanelCustomFieldContainer } from './PublicAssetPanelCustomFieldContainer';

export type PublicAssetPanelCustomFieldDateInputProps = {
  field: AssetCustomFieldValue;
};

export const PublicAssetPanelCustomFieldDateInput = memo(({ field }: PublicAssetPanelCustomFieldDateInputProps) => {
  const assetId = useSelector(centralizedClipAssetIdSelector);
  const { permissions } = usePublicPermissions();
  const canEditCustomFields = canChangeAssetCustomFields(permissions);

  return (
    <PublicAssetPanelCustomFieldContainer field={field}>
      <PublicAssetCustomFieldDateInput
        field={field}
        trackingLocation="asset-details"
        canEditCustomFields={!!canEditCustomFields}
        assetId={assetId}
      />
    </PublicAssetPanelCustomFieldContainer>
  );
});

PublicAssetPanelCustomFieldDateInput.displayName = 'PublicAssetPanelCustomFieldDateInput';
